/**
 * Tenancy participant mutations domain API (Cluster A / A3b.2b).
 *
 * Additive co-tenant mutation path for a tenancy:
 *   GET  /api/admin/tenancies/{id}/mutations              -> history
 *   POST /api/admin/tenancies/{id}/participant-mutations  -> add/end co-tenants
 * The legacy hard-replace PATCH /tenancies/{id} stays untouched.
 */
import {
  API_BASE_URL,
  getApiHeaders,
  expectPaginatedItems,
  parseAdminErrorResponse,
} from "./core";

export function fetchAdminTenancyMutations(tenancyId) {
  const url = `${API_BASE_URL}/api/admin/tenancies/${encodeURIComponent(
    tenancyId
  )}/mutations`;
  return fetch(url, { headers: getApiHeaders() })
    .then((res) => {
      if (!res.ok) throw new Error("Mutationen konnten nicht geladen werden.");
      return res.json();
    })
    .then((data) =>
      expectPaginatedItems(data, "GET /api/admin/tenancies/{id}/mutations")
    );
}

export async function createAdminTenancyParticipantMutation(tenancyId, payload) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/tenancies/${encodeURIComponent(
      tenancyId
    )}/participant-mutations`,
    {
      method: "POST",
      headers: getApiHeaders(),
      body: JSON.stringify(payload),
    }
  );
  if (!res.ok) throw new Error(await parseAdminErrorResponse(res));
  return res.json();
}
